import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { tr } from "../locales/tr.js";

/** Arayüz metinleri Türkçe, anahtarlar İngilizce (AGENTS.md §3.9). Yeni dil eklemek için `locales/` altına kaynak eklenir. */
void i18next.use(initReactI18next).init({
  lng: "tr",
  fallbackLng: "tr",
  resources: { tr: { translation: tr } },
  interpolation: { escapeValue: false },
  returnNull: false,
});

export { i18next };
